// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"headline-module--wrapper--1gesS","primary":"headline-module--primary--2Z6tQ","secondary":"headline-module--secondary--2Fhun","default":"headline-module--default--zrT5S"};